import React, { useState, useEffect } from 'react';
import { Snowflake, TrendingDown, Clock, Package, AlertTriangle } from 'lucide-react';

function DeadStockTab({ token, activeShopId, setSelectedItem }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [days, setDays] = useState(90);

  const fetchDeadStock = async () => {
    setLoading(true);
    try {
      const shopParam = activeShopId ? `&shopId=${activeShopId}` : "";
      const res = await fetch(`/api/analytics/dead-stock?days=${days}${shopParam}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const json = await res.json();
      setData(json);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  useEffect(() => {
    fetchDeadStock();
  }, [activeShopId, days]);

  const totalFrozen = data.reduce((acc, curr) => acc + Number(acc.frozen_value || curr.frozen_value), 0);

  return (
    <div className="space-y-8 animate-in fade-in duration-500">
      <div className="grid grid-cols-3 gap-6">
        <div className="bg-slate-900 p-8 rounded-[40px] border border-blue-500/20 shadow-2xl flex flex-col justify-center relative overflow-hidden">
            <div className="absolute top-0 right-0 p-10 opacity-10"><Snowflake size={120} className="text-blue-400" /></div>
            <p className="text-[10px] font-black text-blue-400 uppercase tracking-widest mb-2">Jami Muzlatilgan Mablag'</p>
            <div className="text-4xl font-black text-white">{Math.round(totalFrozen).toLocaleString()} <span className="text-sm text-blue-500">s</span></div>
            <p className="text-xs text-slate-500 font-bold mt-2">Sotilmay turgan tovarlar qiymati</p>
        </div>

        <div className="bg-slate-900 p-8 rounded-[40px] border border-amber-500/20 shadow-2xl flex flex-col justify-center">
            <p className="text-[10px] font-black text-amber-400 uppercase tracking-widest mb-2">Muzlash Muddati</p>
            <div className="flex gap-2 mt-2">
                {[30, 60, 90, 180].map(d => (
                    <button
                        key={d}
                        onClick={() => setDays(d)}
                        className={`px-4 py-2 rounded-xl text-[10px] font-black transition ${days === d ? 'bg-amber-500 text-white shadow-lg shadow-amber-500/30' : 'bg-white/5 text-slate-500 hover:bg-white/10'}`}
                    >
                        {d}+ KUN
                    </button>
                ))}
            </div>
        </div>

        <div className="bg-rose-500/10 border border-rose-500/20 p-8 rounded-[40px] flex items-center gap-6 shadow-2xl">
            <div className="p-4 bg-rose-500/20 rounded-3xl text-rose-500"><AlertTriangle size={32}/></div>
            <div>
                <h4 className="text-lg font-black text-white">Xavf Darajasi</h4>
                <p className="text-xs text-slate-400 font-bold leading-relaxed">Ushbu tovarlar pul aylanishini sekinlashtirmoqda. Chegirma qilish tavsiya etiladi.</p>
            </div>
        </div>
      </div>

      <div className="bg-slate-900 rounded-[45px] shadow-2xl border border-blue-500/10 overflow-hidden">
        <div className="p-8 border-b border-white/5">
            <h3 className="text-xl font-black text-white flex items-center gap-3"><Clock className="text-blue-400"/> Sotilmay turgan tovarlar ro'yxati</h3>
        </div>
        <table className="w-full text-left">
          <thead>
            <tr className="text-[11px] font-black uppercase text-slate-500 bg-black/20">
              <th className="px-10 py-6 tracking-widest">Mahsulot Nomi</th>
              <th className="px-10 py-6 text-center tracking-widest">Soni</th>
              <th className="px-10 py-6 text-center tracking-widest">Kutilayotgan Kun</th>
              <th className="px-10 py-6 text-right tracking-widest">Muzlagan Summa</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-white/5">
            {data.length === 0 && !loading && (
              <tr>
                <td colSpan="4" className="px-10 py-20 text-center text-slate-500 font-black text-xl opacity-30">
                  Ushbu muddatda muzlagan tovarlar yo'q
                </td>
              </tr>
            )}
            {data.map((item, idx) => (
              <tr key={idx} className="hover:bg-white/5 transition group cursor-pointer" onClick={() => setSelectedItem(item)}>
                <td className="px-10 py-6">
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 rounded-xl bg-slate-800 flex items-center justify-center text-slate-500 border border-white/5">
                       <Package size={18}/>
                    </div>
                    <div>
                      <div className="font-black text-slate-200">{item.product_name}</div>
                      <div className="text-[10px] text-slate-500 font-bold">Eng eski kirim: {new Date(item.oldest_arrival).toLocaleDateString()}</div>
                    </div>
                  </div>
                </td>
                <td className="px-10 py-6 text-center">
                  <span className="bg-slate-800 text-slate-300 px-4 py-1.5 rounded-full text-[10px] font-black uppercase">{item.count} dona</span>
                </td>
                <td className="px-10 py-6 text-center">
                  <span className={`px-4 py-1.5 rounded-full text-[10px] font-black uppercase ${item.days_idle > 180 ? 'bg-rose-500/20 text-rose-500' : 'bg-amber-500/20 text-amber-500'}`}>
                    {Math.round(item.days_idle)} KUN
                  </span>
                </td>
                <td className="px-10 py-6 text-right font-black text-lg text-white">
                  {Math.round(item.frozen_value).toLocaleString()} <span className="text-xs text-slate-600">s</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DeadStockTab;
